module.exports = __webpack_public_path__ + "img/organisation.bce25879.png";